<template>
	<!--<router-view></router-view>-->
	<Panier v-if="path == '/panier/'"/>
	<Caisse v-if="path == '/caisse/'"/>
	<Success v-if="path == '/success/'"/>
	<Connexion v-if="path == '/connexion/'"/>
	<Dashboard v-if="path == '/mon-compte/'"/>
	<Invoice v-if="path == '/commande/'"/>
</template>

<script>
import Panier from './components/ProductCart.vue'
import Caisse from './components/CartCheckout.vue'
import Success from './components/CheckoutSuccess.vue'
import Connexion from './components/CustomerLogin.vue'
import Dashboard from './components/CustomerDashboard.vue'
import Invoice from './components/CustomerInvoice.vue'

export default {
	name: 'App',
	data(){
		return {
			path: window.location.pathname
		}
	},
	components: {
		Connexion,
		Panier,
		Caisse,
		Success,
		Dashboard,
		Invoice
	},
}
</script>
